module.exports = __webpack_public_path__ + "img/dni.6e5fbb57.jpg";